export class IdentityDetails {
  idType:number;
  idNo: string;
  idIssueDate?: Date;
  idExpiryDate?: Date;
  nationalityId: number;
}
